"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridProperties = void 0;
const lodash_1 = __importDefault(require("lodash"));
const PropertyConstants_1 = require("./PropertyConstants");
const gridConfig = __importStar(require("../../resources/grid.json"));
/**
 * Grid property loader
 */
class GridProperties {
    constructor(config) {
        this.extraConfig = config;
    }
    /**
     * Get a property by key
     *
     * @param key
     *            key
     * @param required
     *            true if required
     * @return value
     */
    getProperty(required = false, key) {
        let value = lodash_1.default.get(this.extraConfig, key);
        if (!value) {
            value = lodash_1.default.get(gridConfig, key);
        }
        if (value) {
            value = value.toString();
            if (value.trim().length === 0) {
                value = undefined;
            }
        }
        if (!value && required) {
            throw new Error('Property not found: ' + key);
        }
        return value;
    }
    /**
     * Get an integer property by key
     *
     * @param required
     *            true if required
     * @param key
     *            key
     * @return integer value
     */
    getIntegerProperty(required = false, ...key) {
        let value;
        const stringValue = this.getProperty(required, this.buildProperty(key));
        if (stringValue) {
            value = Number.parseInt(stringValue, 10);
        }
        return value;
    }
    /**
     * Get a float by key
     *
     * @param required
     *            true if required
     * @param key
     *            key
     * @return float value
     */
    getFloatProperty(required = false, ...key) {
        let value;
        const stringValue = this.getProperty(required, this.buildProperty(key));
        if (stringValue) {
            value = Number.parseFloat(stringValue);
        }
        return value;
    }
    /**
     * Get a double by key
     *
     * @param required
     *            true if required
     * @param key
     *            key
     * @return double value
     */
    getDoubleProperty(required = false, ...key) {
        let value;
        const stringValue = this.getProperty(required, this.buildProperty(key));
        if (stringValue) {
            value = +stringValue;
        }
        return value;
    }
    /**
     * Get a boolean by key
     *
     * @param required
     *            true if required
     * @param key
     *            key
     * @return boolean value
     */
    getBooleanProperty(required = false, ...key) {
        let value;
        const stringValue = this.getProperty(required, this.buildProperty(key));
        if (stringValue) {
            value = stringValue.toLowerCase() === 'true';
        }
        return value;
    }
    /**
     * Build a combined property separated by
     * {@link PropertyConstants#PROPERTY_DIVIDER}
     *
     * @param properties
     *            property parts
     *
     * @return combined property
     */
    buildProperty(properties) {
        let combined = '';
        for (const property of properties) {
            if (property) {
                if (combined.length > 0) {
                    combined += PropertyConstants_1.PropertyConstants.PROPERTY_DIVIDER;
                }
                combined += property;
            }
        }
        return combined;
    }
}
exports.GridProperties = GridProperties;
//# sourceMappingURL=GridProperties.js.map